import React from 'react';
import ServicePageTemplate from '../../components/ServicePageTemplate';
import { Smartphone } from 'lucide-react';
import { servicePricing } from '../../mockData';

const MobileApp = () => {
  const features = [
    {
      title: "Native iOS & Android",
      description: "True native apps or cross-platform with React Native/Flutter"
    },
    {
      title: "Push Notifications",
      description: "Keep users engaged with timely, relevant notifications"
    },
    {
      title: "Offline Functionality",
      description: "Apps that work even without internet connection"
    },
    {
      title: "Backend Integration",
      description: "Seamless API integration with your existing systems"
    },
    {
      title: "Analytics & Tracking",
      description: "Understand user behavior with Firebase or Mixpanel"
    },
    {
      title: "App Store Optimization",
      description: "Help your app rank higher and get more downloads"
    }
  ];

  const benefits = [
    {
      title: "Direct Customer Access",
      description: "Be on your customers' home screens for instant access and higher engagement"
    },
    {
      title: "Leverage Device Features",
      description: "Use camera, GPS, accelerometer, and other native features for richer experiences"
    },
    {
      title: "Improved Performance",
      description: "Native apps are faster and more responsive than mobile websites"
    },
    {
      title: "Revenue Opportunities",
      description: "Monetize through in-app purchases, subscriptions, or premium features"
    }
  ];

  const process = [
    {
      title: "Platform Strategy",
      description: "Decide on native vs. cross-platform based on your needs and budget"
    },
    {
      title: "Design & Prototyping",
      description: "Create platform-specific designs following iOS and Android guidelines"
    },
    {
      title: "Development & Testing",
      description: "Build, test on real devices, and optimize performance"
    },
    {
      title: "Store Submission",
      description: "Handle App Store and Google Play submission and approval process"
    }
  ];

  return (
    <ServicePageTemplate
      title="Mobile App Development"
      subtitle="Build Apps Users Love"
      description="Native iOS and Android apps or cross-platform solutions that deliver exceptional user experiences. From concept to App Store, we handle everything."
      features={features}
      benefits={benefits}
      pricing={servicePricing.mobileApp}
      icon={Smartphone}
      bgColor="#b6cbcb"
      process={process}
    />
  );
};

export default MobileApp;